export const navItems = [
  {
    id: "unit5-pricing",
    name: "Pricing",
    link: "",
  },
  {
    id: "unit5-manufacturer-testing",
    name: "Manufacturer Testing",
    link: "",
  },
  {
    id: "unit5-faq",
    name: "FAQ",
    link: "",
  },
  {
    id: "unit5-contact",
    name: "Contact Us",
    link: "",
  },
];
